import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "6",
  viewBox: "0 0 18 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 6V4H2V6H0ZM0 2V0H2V2H0ZM4 6V4H6V6H4ZM4 2V0H6V2H4ZM8 6V4H10V6H8ZM8 2V0H10V2H8ZM12 6V4H14V6H12ZM12 2V0H14V2H12ZM16 6V4H18V6H16ZM16 2V0H18V2H16Z",
      fill: "#DEC8C3"
    }, null, -1)
  ])))
}
export default { render: render }